import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * A ticket's description in a grid cell: one truncated line, the full text in a tooltip on hover/focus.
 * The list API caps descriptions (server/routes.ts → GET /tickets); the ticket page has the full text.
 */
export function TicketDescriptionCell({ description }: { description: string | null | undefined }) {
  const text = (description ?? '').trim();
  if (!text) return <span className="text-muted-foreground/60">—</span>;
  // The cell shows one line, so collapse the description's line breaks there; the tooltip keeps them.
  const oneLine = text.replace(/\s+/g, ' ');
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div tabIndex={0} className="cursor-default truncate text-xs text-muted-foreground outline-none focus-visible:ring-2 focus-visible:ring-ring/40 rounded-sm">
          {oneLine}
        </div>
      </TooltipTrigger>
      <TooltipContent side="bottom" align="start"
        className="max-h-80 max-w-md overflow-y-auto whitespace-pre-wrap break-words text-[12.5px] leading-relaxed">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
